import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DataNotFound } from '../../../components/DataNotFound';
import LoadingAnimation from '../../../components/LoadingAnimation';
import ModalCartSuccessful from '../../../components/elements/ModalCartSuccessfull';
import ProjectsCard from '../../../components/elements/ProjectsCard';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { postAsync } from '../../../components/helper/axiosHelper';
import { updatedCart } from '../../../features/updatedCartSlice';
import { addToCart } from '../../../features/usercartSlice';
import { PageHitCountApi } from '../../../shared/Helper';
import './paymentProcess.scss';
import CampaignsCard from '../../../components/elements/CampaignsCard';
import SMSModal from '../../../components/elements/SMSModal';

const PaymentProcess = () => {
  const dispatch = useDispatch();
  const [apiData, setApiData] = useState([]);
  const [amount, setAmount] = useState('');
  const [paymentMethodId, setPaymentMethodId] = useState(1);
  const [noDataFound, setNoDataFound] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(null);
  const hasMounted = useRef(false);
  const [epUserID, setEpUserID] = useState(null);
  const [projectId, setProjectId] = useState('');
  const [value, setValue] = useState([]);
  const [modalMessageText, setModalMessageText] = useState('');
  const [modalExist, setModalExist] = useState(false);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [previousIndex, setPreviousIndex] = useState(currentIndex);
  const [count, setCount] = useState(1);
  const [errorStates, setErrorStates] = useState([]);
  const [smsModal, setSmsModal] = useState(false);

  const navigate = useNavigate();
  const { id, refferalLink, prossId, projectTypeIdInt } = useParams();

  const { t } = useTranslation();
  const { pathname } = useLocation();
  const token = localStorage.getItem('token');

  const getData = async () => {
    await postAsync('APIClient/ProjectListGUID', [{ ProjectId: id, ProjectTypeIdInt: projectTypeIdInt }])
      .then((response) => {
        const result = response?.data;
        setApiData(result);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
        setIsLoading(false);
        setNoDataFound(true);
      });
  };
  const hitCount = async () => {
    await postAsync('Utilities/ViewHitAPI', {}, { projectID: refferalLink, processID: prossId })
      .then((response) => {
        const result = response?.data;
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    if (apiData && apiData.length > 0) {
      setSelectedValues(Array(apiData.length).fill(1));
    }
  }, [apiData]);

  useEffect(() => {
    localStorage.setItem('isHome', true);
    if (!hasMounted.current) {
      getData();
      hitCount();
      hasMounted.current = true;
    }
  }, []);

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    if (!token) {
      PageHitCountApi(pathname, 0);
    }

    if (token) {
      if (epUserID !== null) {
        PageHitCountApi(pathname, epUserID);
      }
      localStorage.setItem('isHome', false);
    } else {
      localStorage.setItem('isHome', true);
    }
  }, [epUserID]);

  const dataObject = {
    paymentMethodId,
    amount,
    required: true,
  };
  const updateErrorState = (index, isError) => {
    setErrorStates((prevStates) => {
      const newErrorStates = [...prevStates];
      newErrorStates[index] = isError;
      return newErrorStates;
    });
  };

  const DonateHandle = (currentIndex, i, id, price, referralLink, index, isContribution) => {
    let selectedAmount = prossId === '8' || prossId === '9' || prossId === '3' || prossId === '5' ? price : amount ? Number(amount) : 0;

    if (selectedAmount > 0) {
      if (selectedAmount == 0) {
        updateErrorState(index, true);
        return;
      } else {
        updateErrorState(index, false);
        const payload = {
          ...dataObject,
          amount:
            apiData[0]?.sourceType != 3
              ? selectedAmount
              : selectedValues[0] === 2
                ? selectedAmount
                : selectedAmount * 12,
          isContribution,
        };
        const link = `/externalPayment/${id}/${referralLink}/${prossId}/${projectTypeIdInt}`;
        navigate(link, { state: { paymentInfo: payload } });
      }
    } else {
      toast.error(`${t('Amount must be greater than 0')}`);
    }
  };

  const handleOnChange = (index, value) => {
    const newSelectedValues = [...selectedValues];
    newSelectedValues[index] = value;
    setSelectedValues(newSelectedValues);
    setPaymentMethodId(value);
  };

  const handleShareLink = () => { };

  const addCartItem = async (currentIndex, i, price, pId) => {
    try {

      let selectedAmount = prossId === '8' || prossId === '9' || prossId === '3' ? price : amount ? Number(amount) : 0;

      if (selectedAmount > 0) {
        if (selectedAmount !== 0) {
          setIsLoading(true);

          const res = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
          setValue(res?.data);
          dispatch(addToCart(res?.data));

          const response = await postAsync(`APIClient/ProjectListGUID`, [
            { ProjectId: pId, ProjectTypeIdInt: projectTypeIdInt },
          ]);
          if (response) {
            setIsLoading(false);
          }
          const newItem = response?.data;
          const cartbody = {
            cartID: 0,
            projectName: newItem[0]?.projectName || newItem[0]?.titleAr,
            epUserID: epUserID,
            ip: 'string',
            projectID: newItem[0]?.id,
            amount:
              apiData[0]?.sourceType != 3
                ? selectedAmount
                : selectedValues[0] === 2
                  ? selectedAmount
                  : selectedAmount * 12,
            PaymentPeriodID: +paymentMethodId,
            projectTypeIdInt,
          };
          if (token && value.length === 0 && res?.statusCode === 204) {
            await postAsync(`Cart/CreateCart`, cartbody);
            const resp = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
            dispatch(addToCart(resp?.data));
            dispatch(updatedCart(true));
            setModalMessageText('Add to cart Successfully');
            setModalExist(false);
            setGridModalOpen(true);
            return;
          } else if (res.data?.length && res?.statusCode === 200) {
            const itemExistsdatabase = res?.data?.some((item) => item?.projectID === pId);
            if (token && !itemExistsdatabase) {
              await postAsync(`Cart/CreateCart`, cartbody);
              const respo = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
              dispatch(addToCart(respo?.data));
              dispatch(updatedCart(true));
              setModalMessageText('Add to cart Successfully');
              setAmount(0);
              setModalExist(false);
              setGridModalOpen(true);
            } else {
              setModalMessageText('Item  Already Exists');
              setModalExist(true);
              setGridModalOpen(true);
            }
          }

          if (!token) {
            const updateCart = (data) => {
              const updatedData = data.map((item) => {
                if (item.id === newItem[0].id) {
                  return {
                    ...item,
                    price:
                      apiData[0]?.sourceType != 3
                        ? selectedAmount
                        : selectedValues[0] === 2
                          ? selectedAmount
                          : selectedAmount * 12,
                    paymentPeriodID: dataObject?.paymentMethodId,
                  };
                }
                return item;
              });
              localStorage.setItem('cart', JSON.stringify(updatedData));
            };
            // Retrieve existing cart data or create an empty array
            const existingData = JSON.parse(localStorage.getItem('cart')) || [];
            // Check if item exists and update price if needed
            const itemExists = existingData.some((item) => item.id === newItem[0].id);
            if (itemExists) {

              // toast.error('Item already exists.');
              setModalMessageText('Item  Already Exists');
              setModalExist(true);
              setGridModalOpen(true);
              updateCart(existingData);
            } else {

              dispatch(updatedCart(true));
              newItem[0].price =
                apiData[0]?.sourceType != 3
                  ? selectedAmount
                  : selectedValues[0] === 2
                    ? selectedAmount
                    : selectedAmount * 12;
              updateCart([...existingData, ...newItem]);
              setModalMessageText('Add to cart Successfully');
              setAmount(0);
              setModalExist(false);
              setGridModalOpen(true);
            }
          }
        }
        // else {
        //   setprojectGuID(pId);
        // }
      } else {
        toast.error(`${t('Amount must be greater than 0')}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="container-fluid py-5 justify-center">
      <div className="row px-4 pt-10 xl:pt-20 sm:px-5 md:px-5 lg:px-5  justify-center">
        <div className=" py-3 text-center">
          <h1 className="text-3xl text-customgreen  font-bold">{t('Payment Process')}</h1>
        </div>
        {/* {!isLoading ? (
          apiData?.length > 0 ? (
            apiData?.map((data, index) => (
              <ProjectsCard
                key={index}
                i={index}
                data={data}
                handleOnChange={handleOnChange}
                handleShareLink={handleShareLink}
                addCartItem={addCartItem}
                DonateHandle={DonateHandle}
                previousIndex={previousIndex}
                setPreviousIndex={setPreviousIndex}
                setCurrentIndex={setCurrentIndex}
                setCount={setCount}
                setAmount={setAmount}
                amount={amount}
                count={count}
                currentIndex={currentIndex}
                errorStates={errorStates}
                isLoading={isLoading}
                selectedValues={selectedValues}
                setSmsModal={setSmsModal}
                setProjectId={setProjectId}
              />
              <CampaignsCard
              
                    key={index}
                i={index}
                data={data}
                handleOnChange={handleOnChange}
                handleShareLink={handleShareLink}
                addCartItem={addCartItem}
                DonateHandle={DonateHandle}
                previousIndex={previousIndex}
                setPreviousIndex={setPreviousIndex}
                setCurrentIndex={setCurrentIndex}
                setCount={setCount}
                setAmount={setAmount}
                amount={amount}
                count={count}
                currentIndex={currentIndex}
                errorStates={errorStates}
                isLoading={isLoading}
                selectedValues={selectedValues}
                setSmsModal={setSmsModal}
                setProjectId={setProjectId}
              
              />
            ))
          ) : (
            !noDataFound && <DataNotFound />
          )
        ) : (
          <LoadingAnimation
            imageStyling={' sm:pb-0'}
            styling={'flex items-center align-middle justify-center space-x-2'}
          />
        )} */}
        {!isLoading ? (
          apiData?.length > 0 ? (
            apiData?.map((data, index) =>
              prossId == '11' || prossId == '12' || prossId == '13' ? (
                <CampaignsCard
                  key={index}
                  i={index}
                  data={data}
                  handleOnChange={handleOnChange}
                  handleShareLink={handleShareLink}
                  addCartItem={addCartItem}
                  DonateHandle={DonateHandle}
                  previousIndex={previousIndex}
                  setPreviousIndex={setPreviousIndex}
                  setCurrentIndex={setCurrentIndex}
                  setCount={setCount}
                  setAmount={setAmount}
                  amount={amount}
                  count={count}
                  currentIndex={currentIndex}
                  errorStates={errorStates}
                  isLoading={isLoading}
                  selectedValues={selectedValues}
                  setSmsModal={setSmsModal}
                  setProjectId={setProjectId}
                />
              ) : (
                <ProjectsCard
                  key={index}
                  i={index}
                  data={data}
                  handleOnChange={handleOnChange}
                  handleShareLink={handleShareLink}
                  addCartItem={addCartItem}
                  DonateHandle={DonateHandle}
                  previousIndex={previousIndex}
                  setPreviousIndex={setPreviousIndex}
                  setCurrentIndex={setCurrentIndex}
                  setCount={setCount}
                  setAmount={setAmount}
                  amount={amount}
                  count={count}
                  currentIndex={currentIndex}
                  errorStates={errorStates}
                  isLoading={isLoading}
                  selectedValues={selectedValues}
                  setSmsModal={setSmsModal}
                  setProjectId={setProjectId}
                />
              ),
            )
          ) : (
            !noDataFound && <DataNotFound />
          )
        ) : (
          <LoadingAnimation
            imageStyling={' sm:pb-0'}
            styling={'flex items-center align-middle justify-center space-x-2'}
          />
        )}
      </div>
      {noDataFound && <DataNotFound />}
      <ModalCartSuccessful
        modalMessageText={modalMessageText}
        modalExist={modalExist}
        setGridModalOpen={setGridModalOpen}
        gridModalOpen={gridModalOpen}
      />
       {<SMSModal smsModal={smsModal} setSmsModal={setSmsModal} projectId={projectId} />}
    </div>
  );
};

export default PaymentProcess;
